import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { LinkContainer, SecondaryLinkContainer } from './styles';
import Link from '../Link/Link';
import ID_DEFINITION from '../../pageDefinition/constants/idDefinition';
import { setSecondaryLinksData } from '../../redux/modelDataSlice';
import PinMap from '../PinMap/PinMap';
import api from '../../api';
import { recordEvent } from '../../utils/analytics/local';
import { ReactComponent as SimilarProductsIcon } from '../../images/icons/similarProductsIcon.svg';
import { ReactComponent as EvalBoardIcon } from '../../images/icons/evalBoardIcon.svg';

const SecondaryLinks = () => {
	const defaultMappingName = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const opn = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const secondaryLinksDefinition = useSelector(state => state.designDefinition.partDefinition.secondaryLinks);
	const dispatch = useDispatch();
	const [secondaryLinks] = useState(secondaryLinksDefinition);
	const [loading, setLoading] = useState(true);
	const secondaryLinksData = useSelector(state => state.modelData.secondaryLinksData);

	useEffect(() => {
		const createLinksDataRequest = () => {
			const linksParameters = secondaryLinksDefinition.map(column => column.id);
			return {
				opn: defaultMappingName,
				parameters: linksParameters
			};
		};

		const fetchData = async () => {
			try {
				setLoading(true);
				const similarPartUrlPromise = api.gainSimilarProductUrlForOpn(opn);
				const fetchedData = await api.gainParametersForLinks(createLinksDataRequest());

				let updatedData = { ...fetchedData };
				updatedData[ID_DEFINITION.SIMILAR_PRODUCTS] = await similarPartUrlPromise;

				dispatch(setSecondaryLinksData(updatedData));

				setLoading(false);
			} catch (err) {
				console.error(err);
			}
		};
		fetchData();
	}, [dispatch, defaultMappingName, secondaryLinksDefinition, opn]);

	const handleEventRecord = link => {
		recordEvent(link.id, JSON.stringify(defaultMappingName));
	};

	return (
		<SecondaryLinkContainer>
			{!loading && secondaryLinksData[secondaryLinks[0].id] && (
				<LinkContainer key={0}>
					<Link
						href={secondaryLinksData[secondaryLinks[0].id]}
						target="_blank"
						onClick={() => {
							handleEventRecord(secondaryLinks[0]);
						}}>
						<SimilarProductsIcon alt="secondaryLinksDefinitionIcon" height={32} width={32} />
					</Link>
					<Link
						href={secondaryLinksData[secondaryLinks[0].id]}
						target="_blank"
						onClick={() => {
							handleEventRecord(secondaryLinks[0]);
						}}>
						<Typography variant="subtitle2" component="h6" sx={{ ml: 1.5 }}>
							{secondaryLinks[0].heading}
						</Typography>
					</Link>
				</LinkContainer>
			)}
			<PinMap />
			{!loading &&
				secondaryLinks.slice(1).map((link, index) => {
					if (!secondaryLinksData[link.id]) return null;

					return (
						<LinkContainer key={index + 1}>
							<Link
								href={secondaryLinksData[link.id]}
								target="_blank"
								onClick={() => {
									handleEventRecord(link);
								}}>
								<EvalBoardIcon alt="secondaryLinksDefinitionIcon" height={32} width={32} />
							</Link>
							<Link
								href={secondaryLinksData[link.id]}
								target="_blank"
								onClick={() => {
									handleEventRecord(link);
								}}>
								<Typography variant="subtitle2" component="h6" sx={{ ml: 1.5 }}>
									{link.heading}
								</Typography>
							</Link>
						</LinkContainer>
					);
				})}
		</SecondaryLinkContainer>
	);
};

export default SecondaryLinks;
